import React, { useState, useEffect } from "react";
import { Row, Col, FormSelect } from "shards-react";
import useToken from "shared/hook/useToken";
import ReactPaginate from "react-paginate";
import baseUrl from "config/baseUrl";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/es";

const axios = require("axios").default;

const StausQuiryform = styled.span`
  color: ${(props) => props.color || "#000"};
  background-color: ${(props) => props.bg || "#E5E5E6"};
  border-radius: 6px;
  padding: 0px 5px;
  margin-left: 10px;
`;
const QuiryformList = (props) => {
  const { token } = useToken();
  const [dataQuiryformList, setDataQuiryformList] = useState(null);
  const [dataAgencyList, setDataAgencyList] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const [status, setStatus] = useState("");

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          questionnaireId: "",
          questionnaireStatus: status,
        },
        show: 30,
        page: pageNumber,
        orderBy: "questionnaireId",
        orderType: "desc",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/questionnairelist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataQuiryformList(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNumber, status]);

  useEffect(() => {
    var data = JSON.stringify({
      params: {
        agencyTypeId: "",
      },
      show: 100,
      page: 1,
      orderBy: "agencyName",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/agencylist`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setDataAgencyList(response.data);
      })
      .catch(function(error) {
        console.log("setting/agencylist", error);
      });
  }, []);

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };

  const getAgencyName = (agencyId) => {
    const list =
      dataAgencyList != null &&
      dataAgencyList.data.length > 0 &&
      dataAgencyList.data.filter((item) => item.agencyId === agencyId);

    return list.length > 0 ? list[0].agencyName : "";
  };
  const upDateStatus = (id, status) => {
    if (status === 1) {
      var data = JSON.stringify({
        params: {
          questionnaireId: id,
        },
        update: {
          questionnaireStatus: 2,
        },
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/updatequestionnaire`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function(response) {
          window.location = `/administrator/inquiryform/detail/${id}`;
        })
        .catch(function(error) {
          console.log("setting/agencylist", error);
        });
    } else {
      window.location = `/administrator/inquiryform/detail/${id}`;
    }
  };
  const getStatusQuiryformList = (status) => {
    switch (status) {
      case 1:
        return (
          <StausQuiryform bg="#D90000" color="#fff">
            ใหม่
          </StausQuiryform>
        );
      case 2:
        return (
          <StausQuiryform bg="#E5E5E6" color="#000">
            อ่านแล้ว
          </StausQuiryform>
        );
      case 3:
        return (
          <StausQuiryform bg="#7FBC46" color="#fff">
            ตอบกลับแล้ว
          </StausQuiryform>
        );
      default:
        return null;
    }
  };

  const formatDate = (date) => {
    if(date != null){
      const split = date.replace("T"," ").replace(".000Z","").split(" ");
      return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}`;
    }
    return null;
  };
  return (
    <>
      <Row>
        <Col md="12">
          <h6 className="bold" style={{ marginBottom: "30px" }}>
            แบบสอบถามข้อมูล
          </h6>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <h6>สถานะแบบสอบถาม</h6>
          <FormSelect
            value={status}
            onChange={(e) => {
              console.log(e.target.value);
              setStatus(e.target.value);
            }}
          >
            <option value="">ทั้งหมด</option>
            <option value="1">ใหม่</option>
            <option value="2">อ่านแล้ว</option>
            <option value="3">ตอบกลับแล้ว</option>
          </FormSelect>
        </Col>
      </Row>
      <hr/>
      <Row>
        <Col md="12">
          <div
            className="table-responsive"
            style={{ height: "calc(100vh - 225px)" }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col" style={{ minWidth: "150px" }}></th>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    ชื่อ-นามสกุล
                  </th>
                  <th scope="col" style={{ minWidth: "200px" }}>
                    อีเมล
                  </th>
                  <th scope="col" style={{ minWidth: "200px" }}>
                    หน่วยงาน/บริษัท
                  </th>
                  <th scope="col" style={{ minWidth: "125px" }}>
                    เบอร์ติดต่อ
                  </th>
                  <th scope="col" style={{ minWidth: "250px" }}>
                    หัวข้อสอบถาม
                  </th>
                  <th scope="col" style={{ minWidth: "125px" }}>
                    วันที่ส่งข้อมูล
                  </th>
                </tr>
              </thead>
              <tbody className="table-middle">
                {dataQuiryformList != null &&
                dataQuiryformList.data.length > 0 ? (
                  dataQuiryformList.data.map((item, key) => (
                    <tr>
                      <td>{getStatusQuiryformList(item.questionnaireStatus)}</td>
                      <td>
                        <a
                          className="btn-link"
                          onClick={() =>
                            upDateStatus(
                              item.questionnaireId,
                              item.questionnaireStatus
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                        {item.questionnaireFname} {item.questionnaireLname}
                        
                        </a>
                      </td>
                      <td>{item.questionnaireEmail}</td>
                      <td>{getAgencyName(item.agencyId)}</td>
                      <td>{item.questionnairePhone}</td>
                      <td>{item.questionnaireHeadTopic}</td>
                      <td>{formatDate(item.createDate)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}>ยังไม่มีรายการแบบสอบถามข้อมูล</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
        <Col md="12" style={{ textAlign: "right" }}>
          {dataQuiryformList != null && (
            <ReactPaginate
              pageCount={totalPage}
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              nextLabel=">"
              previousLabel="<"
              onPageChange={({ selected }) => {
                nextPage(selected, totalPage);
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default QuiryformList;
